<template>
  <div style="width:99.9%; margin:0 auto;">
    <div class="refund-item" v-for="(refund, index) in refundList" :key="index">
      <div class="table-header" v-if="index === 0">
        <div class="table-header-row3">退款商品</div>
        <div class="table-header-row3">商品属性</div>
        <div class="table-header-row3">单价</div>
        <div class="table-header-row1">数量</div>
        <div class="table-header-row3">交易金额</div>
        <div class="table-header-row3">申请退款金额</div>
        <div class="table-header-row3">买家信息</div>
        <div class="table-header-row2">退款类型</div>
        <div class="table-header-row2">退款原因</div>
        <div class="table-header-row2">操作</div>
      </div>
      <div class="refund-section-title full c-3 f-12 flex-v-sa p-tb5">
        <el-row class="p-l40 lh-30">
          <el-col :span="3">
            <div>
              退款单编号：<span class="c-red">{{ refund.id }}</span>
            </div>
          </el-col>
          <el-col :span="3">
            <div>
              主退款id：<span class="c-red">{{ refund.refundMainId }}</span>
            </div>
          </el-col>
          <el-col :span="3">
            <div>
              订单编号：<span class="c-red">{{ refund.bizOrderId }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="text-right">
              申请时间：<span>{{ refund.gmtCreatedStr }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="m-l32">
              <span class="c-red">{{ getRefundStatus(refund.refundStatus) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="refund-content f-13">
        <div class="refund-content-item row3">
          <div v-if="refund.itemId !== 0" class="w-full">
            <div class="f-14 c-3">{{ refund.itemTitle }}</div>
            <div>商品编号：{{ refund.itemId }}</div>
            <div v-if="refund.supplierName">{{ refund.supplierName }}</div>
          </div>
          <div v-else class="text-center">补款退款</div>
        </div>
        <div class="refund-content-item row3">
          <div class="w-full">
            <div v-for="(item, index) in (refund.detailItemInfo || {}).skuTitleList" :key="index">
              {{ item || '--' }}
            </div>
          </div>
        </div>
        <div class="refund-content-item row3">
          <span class="w-full text-center">
            ￥{{
              refund.detailItemInfo &&
                (refund.detailItemInfo.itemPrice +
                  (refund.detailItemInfo.itemLogisticsPrice || 0) +
                  (refund.detailItemInfo.processFee || 0) +
                  (refund.detailItemInfo.storageFee || 0) +
                  (refund.detailItemInfo.commissionFee || 0) +
                  (refund.detailItemInfo.promiseInterestSubsidyFee || 0) +
                  (refund.detailItemInfo.settleAdjustFee || 0)) /
                  100
            }}
            /
            {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
            <zg-info>
              <div slot="content">
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.itemPrice">
                  商品价格：￥{{ refund.detailItemInfo && refund.detailItemInfo.itemPrice / 100 }} /
                  {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.itemLogisticsPrice">
                  胖猫物流费：￥{{
                    refund.detailItemInfo && refund.detailItemInfo.itemLogisticsPrice / 100
                  }}
                  / {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.processFee">
                  加工费：￥{{ refund.detailItemInfo && refund.detailItemInfo.processFee / 100 }} /
                  {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.storageFee">
                  仓储费：￥{{ refund.detailItemInfo && refund.detailItemInfo.storageFee / 100 }} /
                  {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.commissionFee">
                  委托物流费：￥{{
                    refund.detailItemInfo && refund.detailItemInfo.commissionFee / 100
                  }}
                  / {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div
                  v-if="refund.detailItemInfo && refund.detailItemInfo.promiseInterestSubsidyFee"
                >
                  承兑贴息费：￥{{
                    refund.detailItemInfo && refund.detailItemInfo.promiseInterestSubsidyFee / 100
                  }}
                  / {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
                <div v-if="refund.detailItemInfo && refund.detailItemInfo.settleAdjustFee">
                  结算调差费：￥{{
                    refund.detailItemInfo && refund.detailItemInfo.settleAdjustFee / 100
                  }}
                  / {{ (refund.detailItemInfo || {}).pieceWeightUnit | exUnitToBaseUnit }}
                </div>
              </div>
            </zg-info>
          </span>
        </div>
        <div class="refund-content-item row1">
          <span class="w-full text-center">{{ refund.refundQuality || '--' }}</span>
        </div>
        <div class="refund-content-item row3">
          <span class="f-14 w-full text-center"
            >￥{{ refund.bizAmount | formatMoneyCent | formatPermil }}
          </span>
        </div>
        <div class="refund-content-item row3">
          <span class="c-red f-14 w-full text-center"
            >￥{{ refund.refundAmount | formatMoneyCent | formatPermil }}</span
          >
        </div>
        <div class="refund-content-item row3">
          <div class="w-full">
            <div class="f-14 c-3">
              {{ (refund.detailBuyerInfo && refund.detailBuyerInfo.buyerCompany) || '--' }}
            </div>
            <div>
              <span>{{
                (refund.detailBuyerInfo && refund.detailBuyerInfo.buyerNick) || '--'
              }}</span>
              <i
                class="el-icon-chat-dot-square chat"
                @click="toChat(refund.detailBuyerInfo.userId)"
                v-if="refund.detailBuyerInfo.userId"
              ></i>
            </div>
            <div>{{ (refund.detailBuyerInfo && refund.detailBuyerInfo.phoneNumber) || '--' }}</div>
          </div>
        </div>
        <div class="refund-content-item row2">
          <span class="c-red w-full text-center">{{ getRefundType(refund.refundType) }}</span>
        </div>
        <div class="refund-content-item row2">
          <el-button size="small" type="text" @click="getRefundDetail(refund)">
            查看退款详情
          </el-button>
        </div>
        <div class="refund-content-item row2">
          <div v-if="refund.refundStatus === 1 || refund.refundStatus === 2">
            <div>
              <el-button
                class="btn-text"
                size="mini"
                type="primary"
                plain
                @click="confirmRefund(refund)"
              >
                同意退款
              </el-button>
            </div>
            <div>
              <el-button
                class="btn-text"
                size="mini"
                type="info"
                plain
                style="margin: 10px 0 0 0;"
                @click="refuseReFound(refund)"
              >
                拒绝退款
              </el-button>
            </div>
          </div>
          <el-button size="small" type="text" @click="gotoOrderDetail(refund)">
            查看订单详情
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog title="退款详情" width="40%" center :visible.sync="dialog.dialogVisible">
      <div class="top-info">
        <p>退款类型：{{ getRefundType(refundDetail.refundType) }}</p>
        <p>退款单号：{{ refundDetail.id }}</p>
        <p>申请时间：{{ refundDetail.gmtCreatedStr }}</p>
        <p>
          申请退款金额：<span class="c-red"
            >￥{{ refundDetail.refundAmount | formatMoneyCent | formatPermil }}</span
          >
        </p>
        <p>申请退款原因：{{ refundDetail.refundReason }}</p>
      </div>
      <div
        class="bottom-info"
        v-if="refundDetail.refundStatus === 3 || refundDetail.refundStatus === 4"
      >
        <p>
          退款状态：<span class="c-red">{{ getRefundStatus(refundDetail.refundStatus) }}</span>
        </p>
        <p>
          实际退款金额：<span class="c-red"
            >￥{{ refundDetail.actualRefundAmount | formatMoneyCent | formatPermil }}</span
          >
        </p>
        <p>操作时间：{{ refundDetail.gmtModifiedStr || '--' }}</p>
      </div>
    </el-dialog>

    <refund-approval-dialog
      :visible="dialog.dialogFormVisible"
      :is-approval="isApproval"
      :refund-detail="refundDetail"
      @apply="applyRefund"
      @close="onDialogClose"
    >
    </refund-approval-dialog>
    <refund-tenpay-qrcode
      :visible.sync="tenpayRefundInfo.visible"
      :req-info="tenpayRefundInfo.reqInfo"
      :qrcode-info="tenpayRefundInfo.qrcodeInfo"
      @success="handleTenpayRefundSuccess"
    ></refund-tenpay-qrcode>
  </div>
</template>

<script>
import ZgInfo from '@/components/zg-info'
import RefundApprovalDialog from './refund-approval.vue'
import { refundStatusCode, refuseActionType } from '../code'
import RefundTenpayQrcode from '@/pages/order/components/refund-tenpay-qrcode'
export default {
  name: 'RefundTable',
  components: {
    ZgInfo,
    RefundApprovalDialog,
    RefundTenpayQrcode
  },
  props: {
    refundList: {
      type: Array,
      default: () => []
    },
    parent: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: {
        dialogVisible: false,
        dialogFormVisible: false
      },
      refundDetail: {},
      activeNames: null,
      isApproval: true,
      tenpayRefundInfo: {
        visible: false,
        reqInfo: {
          sellerConfirmOrderRefundPara: null,
          id: null
        },
        qrcodeInfo: {
          expireTime: 0,
          qrCode: ''
        }
      }
    }
  },
  created() {
    this.refundList &&
      this.refundList.forEach(refund => {
        // eslint-disable-next-line
        ;(refund.detailItemInfo || {}).skuTitleList =
          ((refund.detailItemInfo || {}).skuTitleJson &&
            JSON.parse((refund.detailItemInfo || '{}').skuTitleJson)) ||
          []
      })
  },
  methods: {
    getRefundDetail(refund) {
      this.refundDetail = refund
      this.dialog.dialogVisible = true
    },

    confirmRefund(refund) {
      this.isApproval = true
      if (refund.refundType === refuseActionType.GOODS_MONEY) {
        this.confirmRefundAll(refund)
      } else {
        this.refundDetail = refund
        this.dialog.dialogFormVisible = true
      }
    },

    confirmRefundAll(refund) {
      this.$confirm(
        '用户申请全部商品退款，如果同意退款该商品关联的订单将会全部退款',
        '全部退款提醒',
        {
          confirmButtonText: '确认全部退款',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.handleRefund(refund)
      })
    },

    handleRefund(refund) {
      const params = {}
      const {
        id,
        refundType,
        refundMainId,
        refundWay,
        refundStatus,
        bankOrderId = '',
        operateDescription = ''
      } = refund
      if (refundType === refuseActionType.GOODS_MONEY) {
        // 全部退货退款
        params.refundMainId = refundMainId
        params.refundDetailId = id
        params.refundWay = refundWay
        this.isApproval
          ? (params.refundStatus = refundStatusCode.COMFIRM_SELLER)
          : (params.refundStatus = refundStatusCode.REFUSE_SELLER)
      } else if (refundType === refuseActionType.MONEY || refundType === refuseActionType.GOODS) {
        if (this.isApproval) {
          params.refundMainId = refundMainId
          params.refundDetailId = id
          params.refundWay = refundWay
          params.bankOrderId = bankOrderId
          params.refundStatus = refundStatusCode.COMFIRM_SELLER
        } else {
          params.refundMainId = refundMainId
          params.refundDetailId = id
          params.refundStatus = refundStatusCode.REFUSE_SELLER
          params.operateDescription = operateDescription
        }
      }
      this.$post('refund.sellerConfirmOrderRefund', {
        sellerConfirmOrderRefundPara: { ...params }
      }).then(({ success, data }) => {
        if (success && data[0].success) {
          if (data[0].qrCode) {
            this.tenpayRefundInfo.visible = true
            this.tenpayRefundInfo.qrcodeInfo.qrCode = data[0].qrCode
            this.tenpayRefundInfo.qrcodeInfo.expireTime = data[0].qrCode
            this.tenpayRefundInfo.reqInfo.sellerConfirmOrderRefundPara = { ...params }
            this.tenpayRefundInfo.reqInfo.id = id
          } else {
            this.$message({
              type: 'success',
              message: `${this.isApproval ? '退款成功!' : '拒绝退款成功!'}`
            })
            this.parent.getData()
          }
        }
      })
    },
    handleTenpayRefundSuccess() {
      this.$message.success('退款成功')
      this.parent.getData()
    },
    refuseReFound(refund) {
      this.refundDetail = refund
      this.isApproval = false
      this.dialog.dialogFormVisible = true
    },

    applyRefund(form, refund) {
      const params = { ...refund, ...form }
      this.handleRefund(params)
      this.dialog.dialogFormVisible = false
    },

    onDialogClose() {
      this.dialog.dialogFormVisible = false
    },

    gotoOrderDetail({ bizOrderId }) {
      this.$router.push({
        name: 'orderDetail',
        params: {
          id: bizOrderId
        }
      })
    },

    getRefundStatus(status) {
      const {
        INIT,
        WAITING_SELLER,
        COMFIRM_SELLER,
        REFUSE_SELLER,
        SUCCESS,
        FAILD
      } = refundStatusCode
      const refundStatusMap = {
        [INIT]: '退款申请中',
        [WAITING_SELLER]: '等待卖家确认',
        [COMFIRM_SELLER]: '退款中',
        [REFUSE_SELLER]: '卖家拒绝退款',
        [SUCCESS]: '退款成功',
        [FAILD]: '退款失败'
      }
      return refundStatusMap[status]
    },

    getRefundType(type) {
      const { MONEY, GOODS, GOODS_MONEY } = refuseActionType
      const refundTypeMap = {
        [MONEY]: '退款',
        [GOODS]: '退货退款',
        [GOODS_MONEY]: '全部退货退款'
      }
      return refundTypeMap[type]
    },
    toChat(id) {
      console.log(id)
      window.IM &&
        window.IM.show({
          sessionId: id
        })
    }
  }
}
</script>

<style lang="scss" scpoed>
.refund-item + .refund-item {
  margin-top: 20px;
}
.table-header {
  display: flex;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  text-align: center;
  background: #f8f8f8;
  font-size: 12px;
  color: #999;
  div {
    margin-right: 20px;
  }
  &-row3 {
    flex: 3;
  }
  &-row2 {
    flex: 2;
  }
  &-row1 {
    flex: 1;
  }
}
.refund-content {
  display: flex;
  color: #999;
  &-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    line-height: 1.4;
    word-break: break-all;
    border: 1px solid #f0f0f0;
    &:not(:last-child) {
      border-right: 0;
    }
    &.row3 {
      flex: 3;
      &.sku {
        align-items: baseline;
      }
    }
    &.row2 {
      flex: 2;
      .btn-text {
        font-size: 12px;
        padding: 4px 8px !important;
      }
    }
    &.row1 {
      flex: 1;
    }
  }
}
p {
  line-height: 1.8;
}
.top-info {
  margin-bottom: 20px;
}
.bottom-info {
  border-top: 4px solid #d1441b;
  padding-top: 20px;
}
.refund-section-title {
  position: relative;
  background: #f8f8f8;
}
.chat {
  margin-left: 6px;
  font-size: 15px;
}
</style>
